/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Qualifier } from './qualifier';
import { Question } from './question';


export interface IdentificationResultQuestions { 
    idNumber: string;
    /**
     * Displays the message for summary-result.
     */
    identificationFound: IdentificationResultQuestions.IdentificationFoundEnum;
    /**
     * This value indicates if the information submitted matched the information located.
     */
    identificationMatch: IdentificationResultQuestions.IdentificationMatchEnum;
    qualifers: Array<Qualifier>;
    questions: Array<Question>;
}
export namespace IdentificationResultQuestions {
    export type IdentificationFoundEnum = 'Success' | 'Failure' | 'Partial';
    export const IdentificationFoundEnum = {
        Success: 'Success' as IdentificationFoundEnum,
        Failure: 'Failure' as IdentificationFoundEnum,
        Partial: 'Partial' as IdentificationFoundEnum
    };
    export type IdentificationMatchEnum = 'Match' | 'NoMatch' | 'Restricted';
    export const IdentificationMatchEnum = {
        Match: 'Match' as IdentificationMatchEnum,
        NoMatch: 'NoMatch' as IdentificationMatchEnum,
        Restricted: 'Restricted' as IdentificationMatchEnum
    };
}


